import React from 'react';
import { motion } from 'framer-motion';
const features = [{
  numeral: '1',
  title: 'Movimientos Suaves Paso a Paso',
  description: 'Rutinas guiadas, A a Z, que podés seguir incluso si nunca te moviste antes. Como tener una guía al lado tuyo en tu día más cansado.',
  image: 'https://cdn.shopify.com/s/files/1/0996/2510/7821/files/ChatGPT_Image_19_may_2026_12_27_32_p.m..png?v=1779204463'
}, {
  numeral: '2',
  title: 'Diseñado para Días Reales',
  description: 'Rutinas cortas (3, 5, 10 min) pensadas para tu energía real, no para una versión ideal de vos.',
  image: 'https://cdn.shopify.com/s/files/1/0996/2510/7821/files/ChatGPT_Image_19_may_2026_12_30_47_p.m..png?v=1779204657'
}, {
  numeral: '3',
  title: 'Sistema Anti-Culpa',
  description: "No hay 'fallaste'. Cada día tiene su versión suave. Está hecho para que NUNCA abandones.",
  image: 'https://cdn.shopify.com/s/files/1/0996/2510/7821/files/ChatGPT_Image_19_may_2026_12_32_24_p.m..png?v=1779204757'
}, {
  numeral: '4',
  title: 'Alivio Rápido para Cuerpos Rígidos',
  description: 'Micro-resets que disuelven tensión en minutos. Sentís la diferencia desde el primer día.',
  image: 'https://cdn.shopify.com/s/files/1/0996/2510/7821/files/ChatGPT_Image_19_may_2026_12_34_36_p.m..png?v=1779204885'
}, {
  numeral: '5',
  title: '100% Mobile-First, 24/7',
  description: 'Lo abrís desde el teléfono, en la cama, en pijama. Sin presión. Sin horarios. Sin vergüenza.',
  image: 'https://cdn.shopify.com/s/files/1/0996/2510/7821/files/ChatGPT_Image_19_may_2026_12_35_48_p.m..png?v=1779204960'
}];
export function WhatYouGetStack() {
  return <section className="w-full px-5 md:px-8 py-20 md:py-32 bg-base" data-id="element-191">
      <div className="max-w-5xl mx-auto" data-id="element-192">
        <div className="text-center mb-24 md:mb-32" data-id="element-193">
          <h2 className="font-serif text-3xl md:text-5xl text-ink max-w-3xl mx-auto leading-[1.1] tracking-tight" data-id="element-194">
            5 Características que hacen a MOVÉ SUAVE™ 10x mejor que cualquier
            rutina tradicional
          </h2>
        </div>

        <div className="flex flex-col gap-24 md:gap-32" data-id="element-195">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className={`flex flex-col ${index % 2 === 1 ? 'md:flex-row-reverse' : 'md:flex-row'} gap-10 md:gap-16 items-center`} data-id="element-196">
              <div className="w-full md:w-1/2 relative" data-id="element-197">
                <div className="aspect-[4/3] rounded-3xl overflow-hidden bg-secondary/30 p-2 md:p-3" data-id="element-198">
                  <div className="w-full h-full rounded-2xl overflow-hidden" data-id="element-199">
                    <img src={feature.image} alt={feature.title} className="w-full h-full object-cover" data-id="element-200" />
                  </div>
                </div>
                <div className="absolute -top-6 -left-6 md:-top-8 md:-left-8 w-16 h-16 md:w-20 md:h-20 bg-primary text-base rounded-full flex items-center justify-center font-serif text-3xl md:text-4xl shadow-lg" data-id="element-201">
                  {feature.numeral}
                </div>
              </div>

              <div className="w-full md:w-1/2 flex flex-col gap-5" data-id="element-202">
                <h3 className="font-serif text-2xl md:text-3xl text-ink leading-[1.1] tracking-tight" data-id="element-203">
                  {feature.title}
                </h3>
                <p className="text-[17px] md:text-lg text-ink/80 leading-[1.75]" data-id="element-204">
                  {feature.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}